import { NgModule } from '@angular/core';
import { HighlightPipe } from './class.pipe';

@NgModule({
  declarations: [HighlightPipe],
  exports: [HighlightPipe],
})
export class PipesModule {}
